import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../context/AuthContext';
import axios from "axios";
import { getUserDataUrl, getSaveUserDataUrl } from "../constants";
import "./UserEditModal.css";
import { useNavigate } from 'react-router-dom';
import { Typography, Stack } from "@mui/material";

const UserEditModal = ({ visible, onHide, userId, onSave }) => {
    const { token, logout } = useContext(AuthContext);
    const [userData, setUserData] = useState(null);
    const [saveError, setSaveError] = useState(""); // State to store error message
    const navigate = useNavigate();

    useEffect(() => {
        if (visible && userId) {
            axios.get(getUserDataUrl(userId), {
                headers: {
                    Authorization: `Bearer ${token}`, // Pass token here
                    "Content-Type": "application/json",
                },
            })
                .then(response => {
                    const user = response.data.length > 0 ? response.data[0] : null;
                    setUserData(user ? { ...user, moduleAccess: user.moduleAccess || {} } : null);
                    setSaveError(""); // Clear any previous error
                })
                .catch(error => {
                    console.error("Error fetching user:", error);
                    if (error.response && error.response.status === 403) {
                        logout();
                        navigate('/');
                    }
                }
                );
        }
    }, [visible, userId]);

    const handleModuleChange = (module) => {
        setUserData((prevData) => ({
            ...prevData,
            moduleAccess: {
                ...prevData.moduleAccess,
                [module]: !prevData.moduleAccess[module],
            },
        }));
    };

    const handleSaveModuleAccess = () => {
        axios.put(
            getSaveUserDataUrl(userId), // URL
            userData, // Request body (data payload)
            {   // Headers (should be in the third parameter)
                headers: {
                    Authorization: `Bearer ${token}`, // Pass token here
                    "Content-Type": "application/json",
                },
            }
        )
            .then(() => {
                onSave();
                onHide();
            })
            .catch(error => {
                console.error("Error updating user:", error);
                setSaveError("Save failed. Please try again."); // Set error message
                if (error.response && error.response.status === 403) {
                    logout();
                    navigate('/');
                }
            });
    };


    if (!visible) return null;

    return (
        <div className="cm-modal-overlay">
            <div className="cm-modal-box cm-modal-large">
                <button className="cm-close-button" onClick={onHide}>&times;</button>
                <div className="typography-title">Edit User Module Access</div>
                {userData ? (
                    <div className="u-modal-content">
                        <Stack className="emp-info" spacing={1}>
                            <Typography className="emp-label">Employee No: {userData.empNo}</Typography>
                            <Typography className="emp-label">Employee Name: {userData.empName}</Typography>
                        </Stack>
                        <hr className="styled-hr" />
                        <div className="module-access">
                            {Object.keys(userData.moduleAccess).length > 0 ? (
                                Object.entries(userData.moduleAccess).map(([module, access]) => (
                                    <div key={module} className="module-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={access}
                                            onChange={() => handleModuleChange(module)}
                                            className="check-box-access"
                                        />
                                        <label>{module}</label>
                                    </div>
                                ))
                            ) : (
                                <p>No modules available</p>
                            )}
                        </div>
                        {saveError && <p className="error-message">{saveError}</p>} {/* Show error message */}
                        <button className="cm-submit-button" onClick={handleSaveModuleAccess}>Save</button>
                    </div>
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </div>
    );
};

export default UserEditModal;
